import "./plugins/vant.js";
import "@/assets/style/font-awesome-4.7.0/scss/font-awesome.scss";
//全局组件
import "@/components";
//全局过滤器
import "@/filters";
import "@/assets/style/index.scss";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import globalFun from "@/utils/globalFun";
Vue.use(globalFun);
Vue.config.productionTip = false;
process.env.NODE_ENV == "development" ? new VConsole() : false;
// new VConsole() 
new Vue({
    router,
    store,
    render: h => h(App),
}).$mount("#app");